<ls-section-band
  data-testid="page-popular"
  [eyebrow]="'HOME.POPULAR.EYEBROW' | translate"
  [heading]="'HOME.POPULAR.H2' | translate"
  [moreLabel]="'SECTIONS.LISTS.BACK_HOME' | translate"
  [moreLink]="['/', lang()]"
  [moreBack]="true"
  moreTestId="link-back-home">
  <ls-lyric-list-section mode="popular" [paginate]="true" [pageSize]="20" />
</ls-section-band>
